import { useNavigate } from 'react-router-dom'
import { Formik, Field } from 'formik'
import * as Yup from 'yup'
import classnames from 'classnames'
import { useContext, useState } from 'react'
import { StoreContext } from '~/store'
import { addAccount } from '~/lib/api'
import { getLocalizedSlug } from '../'
import Header from '../Header'
import Menu from '../Menu'

export default function AddAccountView() {
  const { user, refreshUser } = useContext(StoreContext)
  const [message, setMessage] = useState()
  const navigate = useNavigate()
  if (!user) return null

  const initialValues = {
    accountNumber: '',
    accountPassword: '',
  }

  const COPY = window.COPY

  return (
    <Formik 
      initialValues={initialValues}
      validationSchema={Yup.object({
        accountNumber: Yup.string().required(),
        accountPassword: Yup.string().required(),
      })}
      onSubmit={async (values) => {
        setMessage('')
        addAccount(user.userId, values.accountNumber, values.accountPassword).then((response) => {
          console.log(response)
          refreshUser()
          navigate(getLocalizedSlug('payment'))
        })
        .catch((error) => {
          console.error(error)
          setMessage(error?.response?.message)
        })
      }}
    >
      {({ errors, submitForm, isSubmitting }) => (
        <section className="add-account-view">
          <Header />
          <div className="my-pages-container">
            <Menu />
            <div className="my-pages-content">
              <h2>{COPY.my_pages.add_account_header}</h2>
              <div className={classnames('my-pages-form add-account-form', { loading: isSubmitting })}>
                <header className="form-header">{COPY.my_pages.account_details_header}</header>
                <div className="form-group">
                  <label htmlFor="accountNumber">{COPY.my_pages.label_account}</label>
                  <Field name="accountNumber" className={classnames('input-field has-label', { 'has-error': errors?.accountNumber })} />
                </div>
                <div className="form-group">
                  <label htmlFor="password">{COPY.my_pages.label_account_password}</label>
                  <Field name="accountPassword" type="password" className={classnames('input-field has-label', { 'has-error': errors?.accountPassword })} placeholder={COPY.my_pages.placeholder_account_password}/>
                </div>
                <div className="form-group with-padding">
                  <div className={classnames('message', { show: message })}>{message}</div>
                  <button id="add-account-button" className="btn" onClick={submitForm}>{COPY.my_pages.save_account_button}</button>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </Formik>
  )
}
